import React from 'react';
import { Container, Card, Alert, Button } from 'react-bootstrap';
import { FaBan, FaExclamationTriangle } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { managerLogout } from '../../backend/firebaseFunctions';
import './CoachAccountBlocked.css';

const CoachAccountBlocked = ({ reason = "payment" }) => {
    const navigate = useNavigate();

    const getBlockReasonText = () => {
        switch (reason) {
            case "payment":
                return "חשבון הארגון שלך מושבת כעת";
            case "trial_ended":
                return "תקופת הניסיון של הארגון הסתיימה";
            case "suspended":
                return "חשבון הארגון שלך הושעה";
            case "pending_approval":
                return "שמתך לארגון ממתינה לאישור";
            case "disabled":
                return "חשבון המאמן שלך הושבת";
            default:
                return "חשבון הארגון שלך מושבת כעת";
        }
    };

    const getBlockReasonDescription = () => {
        switch (reason) {
            case "payment":
                return "המנהל שלך צריך להשלים את תהליך התשלום כדי שתוכל להמשיך להשתמש במערכת. אנא פנה למנהל הארגון שלך.";
            case "trial_ended":
                return "תקופת הניסיון של הארגון הסתיימה. המנהל שלך צריך להשלים את תהליך התשלום כדי להמשיך להשתמש במערכת.";
            case "suspended":
                return "חשבון הארגון שלך הושעה מסיבות שונות. אנא פנה למנהל הארגון שלך או לתמיכה.";
            case "pending_approval":
                return "שמתך נשלחה למנהל הארגון לאישור. ברגע שהמנהל יאשר את הרשמתך, תוכל להתחיל להשתמש במערכת.";
            case "disabled":
                return "חשבון המאמן שלך הושבת על ידי מנהל הארגון. אנא פנה למנהל הארגון שלך כדי להבין את הסיבה ולפתור את הבעיה.";
            default:
                return "חשבון הארגון שלך מושבת כעת. אנא פנה למנהל הארגון שלך או לתמיכה.";
        }
    };

    const handleLogout = async () => {
        try {
            await managerLogout();
            navigate('/manager/auth');
        } catch (error) {
            console.error('Error during logout:', error);
            // Even if logout fails, still navigate to auth page
            navigate('/manager/auth');
        }
    };

    return (
        <div className="coach-blocked-container" dir="rtl">
            <Container className="py-5">
                <Card className="coach-blocked-card" style={{ maxWidth: '600px', margin: '0 auto' }}>
                    <Card.Body className="text-center p-5" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'right' }}>
                        <div className="mb-4">
                            <div className="coach-blocked-icon-container"
                                style={{ width: '120px', height: '120px' }}>
                                <FaBan size={64} className="text-white" />
                            </div>
                        </div>

                        <h2 className="coach-blocked-title">{getBlockReasonText()}</h2>

                        <Alert variant="warning" className="coach-blocked-alert mb-4 text-start">
                            <div className="d-flex align-items-center mb-3">
                                <FaExclamationTriangle className="me-2 text-warning" />
                                <strong className="text-dark">הסבר:</strong>
                            </div>
                            <p className="coach-blocked-description mb-0" style={{ textAlign: 'right' }}>
                                {getBlockReasonDescription()}
                            </p>
                        </Alert>

                        <div className="d-grid gap-2 d-md-block">
                            <Button
                                variant="outline-secondary"
                                onClick={handleLogout}
                                className="coach-blocked-button me-md-2 px-4 py-2"
                                size="lg"
                            >
                                התנתק מהמערכת
                            </Button>
                        </div>
                    </Card.Body>
                </Card>
            </Container>
        </div>
    );
};

export default CoachAccountBlocked;
